import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { useRecordContext } from "react-admin";
import { useForm } from "react-hook-form";
import ProductLinkButton from "./ProductLinkButton";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
export default function Alerts({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "alerts";
  const sectionTitle =
    "Alerts - Set up automated alert emails to parties throughout the review process";
  const sectionSubtitle = "";

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.alerts;
  const [showDetail, setShowDetail] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        affiliation: data?.affiliation || [],
        communityZip: data?.communityZip || "",
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box sx={{ padding: "10px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ProductLinkButton
              title="Review System Generated Alerts"
              href="/banks"
            />
          </Grid>
          {/* Form Actions */}
          <Grid item xs={12} container justifyContent="flex-end" spacing={2}>
            <Grid item></Grid>
          </Grid>
        </Grid>
      </Box>
    </SectionStyled>
  );
}
